// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1vINE","empty":"ModalGraph_empty__3VuFe"};